import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { Col, Row, Button, Label, FormGroup, Input } from "reactstrap";
import { Form, Field } from "react-final-form";
import { useNavigate, useLocation, useParams, Link } from 'react-router-dom';
import AuthService from "./auth.service";
import AlertService from "../../components/Alerts/alerts";
import { ToastContainer } from 'react-toastify';
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import "../../assets/custom css/loadoverlay.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTimes, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import bg from './bg.png';
import Swal from 'sweetalert2';

const Register = () => {
  const [loading, setLoading] = useState(false);
  const [logo, setLogo] = useState(localStorage.getItem("system_logo"));
  // const [documents, setDocuments] = useState([]);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const params = useParams();
  const location = useLocation();
  var pathname = location.pathname;
  pathname = pathname.split('/')[2];
  const usertype = pathname;

  useEffect(() => {
    getSetLanguage();
  }, []);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

const styles = {
  container: {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    height: '100%',
    minHeight: '100vh',
    alignItems: 'stretch',
    justifyContent: isMobile ? 'flex-start' : 'space-between',
    padding: isMobile ? '20px' : '0',
    backgroundColor: isMobile ? '#f5f7fa' : 'transparent',
  },
  leftContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    background: 'white',
    padding: isMobile ? '25px 20px' : '0 50px',
    boxShadow: isMobile ? '0 4px 16px rgba(0,0,0,0.1)' : '0 4px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: isMobile ? '12px' : '0',
    marginTop: isMobile ? '0' : '1%',
    maxWidth: isMobile ? '100%' : 'none',
  },
  rightContainer: {
    flex: 1,
    display: isMobile ? 'block' : 'flex',
    margin: isMobile ? '20px 0 0 0' : '1%',
    height: isMobile ? '200px' : 'auto',
    borderRadius: '12px',
    backgroundImage: `url(${bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  overlayText: {
    position: 'absolute',
    top: '1%',
    left: '10%',
    color: 'white',
    textAlign: 'left',
    padding: '20px',
    backgroundColor: 'rgba(72, 132, 194, 0.5)',
  },
  logoContainer: {
    marginBottom: isMobile ? '15px' : '5px',
    display: 'flex',
    justifyContent: isMobile ? 'center' : 'flex-start',
  },
  logo: {
    width: isMobile ? '160px' : '200px',
    height: 'auto',
  },
  heading: {
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '10px',
    textAlign: isMobile ? 'center' : 'left',
  },
  logoText: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '20px',
    textAlign: isMobile ? 'center' : 'left',
  },
  formFooter: {
    display: 'flex',
    justifyContent: isMobile ? 'center' : 'space-between',
    alignItems: 'center',
    flexDirection: isMobile ? 'column' : 'row',
    gap: isMobile ? '10px' : '0',
  },
  rememberMe: {
    display: 'flex',
    alignItems: 'center',
  },
  checkboxLabel: {
    marginLeft: '5px',
  },
  forgotPassword: {
    color: '#007bff',
    textDecoration: 'none',
  },
};


  function getSetLanguage() {
    const language = localStorage.getItem("language") || 'en';
    i18n.changeLanguage(language);
  }

  const onSubmit = async (values) => {
    setLoading(true);

    const formData = {
      ...values,
      // Backend expects `RegistrationNumber`; map from the APC input
      RegistrationNumber: values.apc_number,
      // Address: address,
      user_type_id: '6576b4b4e66749ea4ce13108',
      user_type: usertype,
      all_required_have: 'false',
      status: 'pending',
    };

    try {
      const response = await AuthService.Register_Doctor(formData);
      setLoading(false);
      //iph todo: 47
      //console.log("Response:", response);

      if (response.data.status) {
        AlertService.successToast("SignUp Successful. Login Now");
        Swal.fire({
          title: 'Registration Successful!',
          text: 'Account created successfully, please check your email for login credentials',
          icon: 'success',
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            navigate(`/user-login/${formData.user_type}`);
          }
        });
      } else if (response.data.message === 'Email or Registration Number Already Registered') {
        AlertService.swalErrorAlert("Email or Registration Number Already Exists");
      }
    } catch (error) {
      setLoading(false);
      const resMessage = error.response?.data?.message || error.message || "An error occurred";
      AlertService.swalErrorAlert(resMessage);
    }
  };

  const validateForm = (values) => {
    const errors = {};
    if (!values.name) errors.name = t('Name is required');
    if (!values.email) errors.email = t('Email is required');
    if (!values.clinic_name) errors.clinic_name = t('Clinic Name is required');
    if (!values.apc_number) errors.apc_number = t('APC Number is required');
    if (!values.phone) errors.phone = t('Phone is required');
    return errors;
  };

  return (
    <div style={styles.container}>
      <div style={styles.leftContainer}>
        <div style={styles.logoContainer}>
          <img src={logo} alt="Logo" style={styles.logo} />
        </div>
        <Form
          onSubmit={onSubmit}
          validate={validateForm}
          render={({ handleSubmit, valid }) => (
            <form onSubmit={handleSubmit}>
              <LoadingOverlay active={loading} spinner={<DNALoader />}>
                <div className="modal-body">
                  <h2 style={styles.heading}>{t('Sign Up')}</h2>
                  <p style={styles.logoText}>{t('Create Account For Doctor.')}</p>
                  <Row form>
                    <Col md={12}>
                      <Field name="clinic_name">
                        {({ input, meta }) => (
                          <FormGroup>
                            <Label>{t('Clinic Name')}</Label>
                            <Input {...input} type="text" placeholder={t('Enter Clinic Name')} invalid={meta.error && meta.touched} />
                            {meta.error && meta.touched && <span className="text-danger">{meta.error}</span>}
                          </FormGroup>
                        )}
                      </Field>
                    </Col>
                    <Col md={6}>
                      <Field name="name">
                        {({ input, meta }) => (
                          <FormGroup>
                            <Label>{t('Doctor Name')}</Label>
                            <Input {...input} type="text" placeholder={t('Enter Doctor Name')} invalid={meta.error && meta.touched} />
                            {meta.error && meta.touched && <span className="text-danger">{meta.error}</span>}
                          </FormGroup>
                        )}
                      </Field>
                    </Col>
                    <Col md={6}>
                      <Field name="email">
                        {({ input, meta }) => (
                          <FormGroup>
                            <Label>{t('Email')}</Label>
                            <Input {...input} type="email" placeholder={t('Enter Email')} invalid={meta.error && meta.touched} />
                            {meta.error && meta.touched && <span className="text-danger">{meta.error}</span>}
                          </FormGroup>
                        )}
                      </Field>
                    </Col>
                    <Col md={6}>
                      <Field name="phone">
                        {({ input, meta }) => (
                          <FormGroup>
                            <Label>{t('Phone Number')}</Label>
                            <Input {...input} type="number" placeholder={t('Enter Phone Number')} invalid={meta.error && meta.touched} />
                            {meta.error && meta.touched && <span className="text-danger">{meta.error}</span>}
                          </FormGroup>
                        )}
                      </Field>
                    </Col>
                    <Col md={6}>
                      <Field name="apc_number">
                        {({ input, meta }) => (
                          <FormGroup>
                            <Label>{t('APC Number')}</Label>
                            <Input {...input} type="text" placeholder={t('Enter APC Number')} invalid={meta.error && meta.touched} />
                            {meta.error && meta.touched && <span className="text-danger">{meta.error}</span>}
                          </FormGroup>
                        )}
                      </Field>
                    </Col>
                  </Row>
                  <div className="d-grid mb-3">
                    <Button size="lg" className="btn-custom-color" type="submit" disabled={!valid}>
                      {t('Sign Up')}
                    </Button>
                  </div>
                  <div className="text-center">
                    {t('Already Have an Account?')}
                    <Link to={`/user-login/${usertype}`} style={{ color: '#007bff', textDecoration: 'none', marginLeft: '5px' }}>
                      {t('Login')}


                    </Link>
                  </div>
                </div>
              </LoadingOverlay>
            </form>
          )}
        />
      </div>
      <div style={styles.rightContainer}>
        {/* <SliderComponent /> */}
      </div>
      <style>{`
        .pac-container {
          z-index: 1500 !important;
        }
      `}</style>
    </div>
  );
};

export default Register;
